import axios from "axios";
import { toast } from "react-toastify";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

API.interceptors.request.use(config => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = token;
  }
  return config;
});

// Only redirect on 401, and do it carefully
API.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error?.response?.data?.status;
    if (status === 401) {
      toast.error("Session expired. Please login again.");
      setTimeout(() => {
        localStorage.removeItem("token");
        window.location.href = "/";
      }, 1500);
    }
    return Promise.reject(error);
  }
);

export default API;
